import { isOnline } from "@/utils/connectivity";
import { cacheAppShellAssets } from "@/utils/cacheAppShell";

let prefetchInFlight = null;

/**
 * Fuerza la descarga de los chunks lazy de rutas offline-críticas
 * y los manda al Service Worker para poder navegar sin internet.
 */
export async function prefetchOfflineShellChunks() {
  if (!isOnline()) return;
  if (prefetchInFlight) return prefetchInFlight;

  prefetchInFlight = (async () => {
    await Promise.allSettled([
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/ProductsListView.vue"
      ),
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/CajaActualView.vue"
      ),
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/StockView.vue"
      ),
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/MesasView.vue"
      ),
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/ProductNewView.vue"
      ),
      // Dependencias frecuentes de esas pantallas (aparecen como chunks aparte).
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/DevicesView.vue"
      ),
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/TicketConfigView.vue"
      ),
      import(
        /* webpackChunkName: "dashboard" */ "@/views/dashboard/EtiquetasGondolaView.vue"
      ),
    ]);

    // Dejar que el navegador registre los resources en performance timeline.
    await new Promise((r) => setTimeout(r, 300));
    await cacheAppShellAssets();
  })()
    .catch((err) => {
      console.warn("[sw] prefetchOfflineShellChunks:", err);
    })
    .finally(() => {
      prefetchInFlight = null;
    });

  return prefetchInFlight;
}
